import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';
import '../static/common.css';

import $ from 'jquery' // 导入jQuery库
window.$ = window.jQuery = $ // 设置全局变量$为jQuery对象
Vue.use(ElementUI);
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
